export default "__VITE_PUBLIC_ASSET__c18e212a__"